import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ClassesAndGroups from './ClassesAndGroups'
import ClassesAndGroupDetailPage from './ClassesAndGroupDetailPage'
import ClassStudentDetailPage from './ClassStudentDetailPage'
import TeacherDetailPage from './TeacherDetailPage'

const TeacherClassesAndGroupsRoutes = ({ view = "all" }) => {
    return (
        <>
            <Routes>
                <Route
                    path='/'
                    element={<ClassesAndGroups view={view} />}
                />
                <Route
                    path='/:classId/students/:studentId'
                    element={<ClassStudentDetailPage />}
                />
                <Route
                    path='/:classId/teachers/:teacherId'
                    element={<TeacherDetailPage />}
                />
                <Route
                    path='/:id'
                    element={<ClassesAndGroupDetailPage />}
                />


            </Routes>
        </>
    )
}

export default TeacherClassesAndGroupsRoutes